import { Tab, TabProps, Tabs, withStyles } from '@material-ui/core';
import { DARK_BG_CARD } from '@src/muithemes/darkModeColors';

/**
 * Shared "segmented" tab look used across the app (contact info panel, chat
 * inbox trays, …): a card-colored container with rounded top corners and a
 * flat, primary-colored indicator under the active tab. The selected tab's light
 * lavender fill is inherited from the global `MuiTab` `&$selected` override in
 * `b2ChatTheme`, so it resolves correctly in both light and dark mode.
 *
 * Consumers layer their own specifics on top via `className` (fixed widths,
 * taller rows for icons, …) and `TabIndicatorProps` (e.g. a warning-colored
 * indicator) without duplicating the base appearance.
 */
export const SegmentedTabs = withStyles(theme => ({
  root: {
    backgroundColor:
      theme.palette.type === 'dark' ? DARK_BG_CARD : theme.palette.grey[100],
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    minHeight: 44,
  },
  indicator: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 0,
  },
}))(Tabs);

export const SegmentedTab = withStyles(theme => ({
  root: {
    minWidth: 'auto',
    minHeight: 44,
    padding: '6px 16px',
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontSize: 13,
    fontWeight: 500,
    borderRadius: 0,
    color: theme.palette.text.secondary,
    '&:focus': { opacity: 1 },
    // Double ampersand bumps specificity above the global theme's `&$selected`
    // MuiTab override so the rounded top corners apply on the active tab.
    '&&.Mui-selected': {
      fontWeight: 600,
      color: theme.palette.primary.main,
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8,
    },
  },
}))((props: TabProps) => <Tab disableRipple {...props} />);
